import { Component, Input, OnInit } from '@angular/core';
import { ActionSheetController, ModalController, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { SquareService } from 'src/app/services/square.service';
import { AddEditSquareComponent } from '../add-edit-square/add-edit-square.component';

@Component({
  selector: 'app-square-card',
  templateUrl: './square-card.component.html',
  styleUrls: ['./square-card.component.scss'],
})
export class SquareCardComponent implements OnInit {

  @Input() public id: any;
  @Input() public square: any;

  constructor(
    public authService: AuthService,
    public squareService: SquareService,
    public modalController: ModalController,
    public actionSheetController: ActionSheetController,
    public navController: NavController
  ) {

  }

  ngOnInit() {
    console.log(this.square);
    this.id = this.square.id;
    if (this.id && !this.square) {
      this.squareService.getSquare(this.id).then((square) => {
        this.square = square;
      });
    }
  }


  async presentActionSheet(square) {
    const actionSheet = await this.actionSheetController.create({
      header: 'Options',
      cssClass: 'feeds-action-sheet',
      buttons: [{
        text: 'Open',
        icon: 'open-outline',
        cssClass: 'feeds-action-sheet-btn',
        handler: () => {
          console.log('Open clicked');
          this.openDetailPage(square);
        }
      },
      {
        text: 'Edit',
        icon: 'create-outline',
        cssClass: 'feeds-action-sheet-btn',
        handler: () => {
          console.log('Open clicked');
          this.editGroup(square);
        }
      },
      {
        text: 'Like',
        icon: 'thumbs-up-sharp',
        handler: () => {
          this.like(square);
        }
      },
      {
        text: 'Share',
        icon: 'share-outline',
        handler: () => {
        }
      },
      {
        text: 'Cancel',
        icon: 'close-outline',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  async editGroup(square) {
    const modal = await this.modalController.create({
      component: AddEditSquareComponent,
      cssClass: 'add-edit-square-modal',
      initialBreakpoint: 0.8,
      breakpoints: [0, 0.8, 1],
      componentProps: {
        square,
      }
    });

  }

  gotToComment(square: any) {
    throw new Error('Method not implemented.');
  }
  like(square: any) {
    throw new Error('Method not implemented.');
  }
  openDetailPage(square: any) {
    this.navController.navigateForward(['/square', square.id]);
  }


  ionviewDidLeave() {

  }

}
